import { environment } from '@environment';
import {
  createATInternetConfig,
  createFacebookPixelConfig,
  createGoogleRetargetingConfig,
  createHotjarConfig,
  createSnapchatPixelConfig,
  createWizbiiAnalyticsConfig,
  TrackingConfig,
} from '@wizbii/tracking';

export const trackingConfig: TrackingConfig = {
  informationGroupKeys: ['technical'],
  uuidSetterDomain: `https://a.${environment.apiDomain1j1s}`,
  consentWidget: {
    version: environment.platform !== 'prod' ? 'staging' : '',
    apiDomain: environment.apiDomain1j1s,
    wizbiiApiDomain: environment.apiDomain,
    enableTermsModal: true,
    locale: 'fr',
    productId: environment.applicationId,
    productLabel: '1 jeune, 1 solution',
    defaultValue: false,
    labels: {},
    legalUrlBanner: `https://${environment.apiDomain1j1s}/confidentialite`,
    rejectAll: true,
  },
  trackers: {
    analytics_wizbii: createWizbiiAnalyticsConfig(
      environment.analytics.waTrackingId,
      `https://a.${environment.apiDomain1j1s}`
    ),
    // analytics_google: createGoogleAnalyticsConfig(environment.analytics.gaTrackingId),
    ...(environment.platform === 'prod'
      ? { marketing_google: createGoogleRetargetingConfig(environment.analytics.gtagTrackingId) }
      : {}),

    ...(environment.platform === 'prod'
      ? { analytics_at_internet: createATInternetConfig(environment.analytics.atInternetId) }
      : {}),
    analytics_hotjar: createHotjarConfig({
      hjid: environment.analytics.hotjar.id,
      hjsv: environment.analytics.hotjar.version,
    }),
    ...(environment.platform === 'prod'
      ? {
          analytics_facebook_pixel: createFacebookPixelConfig({
            appId: environment.analytics.facebookPixel.appId,
            version: environment.analytics.facebookPixel.version,
            locale: environment.i18n.locale,
          }),
        }
      : {}),
    ...(environment.platform === 'prod'
      ? {
          analytics_snapchat_pixel: createSnapchatPixelConfig({ appId: environment.analytics.snapchatId }),
        }
      : {}),
  },
  canDisableWizbiiAnalytiks: true,
};
